var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _RecentActionsState_commandUuids, _RecentActionsState_itemUuids;
const MaxCommands = 5;
const MaxItems = 10;
export class RecentActionsState {
    constructor() {
        _RecentActionsState_commandUuids.set(this, []);
        _RecentActionsState_itemUuids.set(this, []
        /**
         * Recently used commands, most recent at the start
         */
        );
    }
    /**
     * Recently used commands, most recent at the start
     */
    get commandUuids() {
        return __classPrivateFieldGet(this, _RecentActionsState_commandUuids, "f");
    }
    /**
     * Recently opened items, most recent at the start
     */
    get itemUuids() {
        return __classPrivateFieldGet(this, _RecentActionsState_itemUuids, "f");
    }
    add(id, action_type = 'item') {
        const action_array = action_type === 'item' ? __classPrivateFieldGet(this, _RecentActionsState_itemUuids, "f") : __classPrivateFieldGet(this, _RecentActionsState_commandUuids, "f");
        const existing = action_array.findIndex((uuid) => uuid === id);
        if (existing !== -1) {
            action_array.splice(existing, 1);
        }
        const max = action_type === 'item' ? MaxItems : MaxCommands;
        if (action_array.length == max) {
            action_array.pop();
        }
        action_array.unshift(id);
    }
}
_RecentActionsState_commandUuids = new WeakMap(), _RecentActionsState_itemUuids = new WeakMap();
